@if (backdrop) {
<div class="loader-backdrop"></div>
}

<div class="loader-icon">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
